<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="所属分类" prop="problemTypeId">
        <a-select placeholder="请选择" allowClear v-model="form.problemTypeId">
          <a-select-option v-for="(d, index) in problemTypeOptions" :key="index" :value="d.id" >{{ d.title }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="问题标题" prop="title" >
        <a-input v-model="form.title" placeholder="请输入问题标题" />
      </a-form-model-item>
      <a-form-model-item label="问题简述" prop="sketch" >
        <a-input v-model="form.sketch" placeholder="请输入问题简述"  type="textarea" allow-clear  />
      </a-form-model-item>
      <a-form-model-item label="问题内容" prop="contentInfo" >
        <editor v-model="form.contentInfo" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="显示顺序" prop="orderSort" >
        <a-input v-model="form.orderSort" placeholder="请输入序号" type="number" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="是否开启" prop="status">
        <!-- 1正常 0停用 -->
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button v-for="(d, index) in statusOptions" :key="index" :value="d.value">
            {{ d.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getProblem, addProblem, updateProblem } from '@/api/problem/problem'
import Editor from "@/components/Editor";

export default {
  name: 'CreateForm',
  props: {
    problemTypeOptions: {
      type: Array,
      required: true
    }
  },
  components: {
    Editor
  },
  data () {
    return {
      replaceFields: { children: 'children', title: 'label', key: 'id', value: 'id' },
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        problemTypeId: null,
        title: null,
        sketch: null,
        contentInfo: null,
        orderSort:null,
        status: 0,
        remark: null
      },
      statusOptions: [
        {
          label: '正常',
          value: 1
        },
        {
          label: '停用',
          value: 0
        }
      ],
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        problemTypeId: [
          { required: true, message: '所属分类不能为空'}
        ],
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        sketch: [
          { required: true, message: '问题简述不能为空', trigger: 'blur' }
        ],
        contentInfo: [
          { required: true, message: '问题内容不能为空', trigger: 'blur' }
        ],
        orderSort: [
          { required: true, message: '显示排序不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1

      this.$nextTick(() => {this.form = {
        id: null,
        problemTypeId: undefined,
        title: null,
        sketch: null,
        contentInfo: null,
        orderSort:null,
        status: 0,
        remark: null
      }

        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getProblem({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateProblem(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addProblem(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
